module.exports = __webpack_public_path__ + "static/media/strip-cellphone-palm.22a707c4.png";